import React, { useEffect, useRef } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import clickSound from "../../../Assets/sounds/click.mp3";
import { motion } from "framer-motion";

const StoryNavigation = ({
  stories,
  loading,
  currentStoryIndex,
  setCurrentStoryIndex,
  setLastActiveIndex,
  setSocketres,
  isRecording,
}) => {
  const audioRef = useRef(new Audio(clickSound));
  
  const playClickSound = () => {
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(err => console.error("Error playing sound:", err));
  };

  const handleNext = () => {
    if (loading) return;
    playClickSound();
    const nextIndex =
      currentStoryIndex === stories.length - 1 ? 0 : currentStoryIndex + 1;
    setCurrentStoryIndex(nextIndex);
    setLastActiveIndex(nextIndex);
    setSocketres(null);
  };

  const handlePrevious = () => {
    if (loading) return;
    playClickSound();
    const prevIndex =
      currentStoryIndex === 0 ? stories.length - 1 : currentStoryIndex - 1;
    setCurrentStoryIndex(prevIndex);
    setLastActiveIndex(prevIndex);
    setSocketres(null);
  };

  if (isRecording) {
    return null;
  }

  return (
    <div className="w-full flex justify-center items-center gap-6 mt-6 mb-8 px-8">
      {stories?.length > 0 && (
        <>
          {/* Previous Button */}
          <motion.button
            whileHover={{ scale: 1.02, x: -2 }}
            whileTap={{ scale: 0.98 }}
            onClick={handlePrevious}
            disabled={loading}
            className={`flex items-center gap-3 px-8 py-3 rounded-xl font-bold transition-all duration-300 shadow-sm border ${
              loading 
                ? "bg-slate-50 text-slate-300 border-slate-100 cursor-not-allowed" 
                : "bg-white text-slate-600 border-slate-200 hover:border-blue-400 hover:text-blue-600 hover:shadow-md"
            }`}
          >
            <ArrowLeft size={20} strokeWidth={2.5} />
            <span className="uppercase tracking-widest text-[13px]">Previous Passage</span>
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.02, x: 2 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleNext}
            disabled={loading}
            className={`flex items-center gap-3 px-10 py-3 rounded-xl font-bold transition-all duration-300 shadow-md ${
              loading 
                ? "bg-slate-100 text-slate-400 cursor-not-allowed" 
                : "bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg shadow-blue-200 hover:scale-[1.03]"
            }`}
          >
            <span className="uppercase tracking-widest text-[13px]">Next Passage</span>
            <ArrowRight size={20} strokeWidth={2.5} />
          </motion.button>
        </>
      )}
    </div>
  );
};

export default StoryNavigation;